import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import styled from "styled-components"
import AnimeButton from "../components/AnimeButton"
import containURL from "../components/continueURL"

const WhiteButton = styled(Button)`
  width: 207px;
  height: 45px;
  margin: auto;
  border: 1px solid #6e6e6e;
  text-align: center;
  border-radius: 0;
`

const BlackButton = styled(Button)`
  width: 207px;
  height: 45px;
  margin: auto;
  border: 1px solid #6e6e6e;
  background: #6e6e6e;
  text-align: center;
  border-radius: 0;
`

function Top() {
  const data = useStaticQuery(graphql`
    query {
      topImage: file(relativePath: { eq: "group16@2x.png" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div style={{ position: "relative", marginBottom: "40px" }}>
      <div style={{ width: "100%", height: "100%" }}>
        <Img fluid={data.topImage.childImageSharp.fluid} />
      </div>
      <Hidden xsDown>
        <div style={{ position: "absolute", top: "26%", left: "20%" }}>
          <ButtonComponent2 />
        </div>
        <div style={{ position: "absolute", top: "26%", right: "10%" }}>
          <ButtonComponent />
        </div>
        <div style={{ position: "absolute", top: "98.7%", right: "18.7%" }}>
          <ButtonComponent3 />
        </div>
      </Hidden>
      <Hidden smUp>
        <div style={{ position: "absolute", top: "26%", left: "14%" }}>
          <ButtonComponent2Sp />
        </div>
        <div style={{ position: "absolute", top: "26%", right: "13%" }}>
          <ButtonComponentSp />
        </div>
        <div style={{ position: "absolute", top: "98.7%", right: "18.7%" }}>
          <ButtonComponent3Sp />
        </div>
      </Hidden>
    </div>
  )
}

function ButtonComponent() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <AnimeButton
          href="/product/"
          text="詳しく見る"
          width="200px"
          height="40px"
          fs="16px"
          color="#fff"
          border="solid 1px #fff"
          bgColor="#fff"
          afterColor="#565656"
        />
      </div>
    </>
  )
}

function ButtonComponentSp() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <Link to={"/product/"}>
          <WhiteButton
            style={{ fontSize: "10px", width: "100px", height: "20px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p>購入はこちら</p>
            </div>
          </WhiteButton>
        </Link>
      </div>
    </>
  )
}

function ButtonComponent2() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <Link
          to={containURL(
            "https://unfilter.co.jp/shop/cart/add?variant_id=1&quantity=1"
          )}
        >
          <BlackButton>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p style={{ color: "#ffffff" }}>購入はこちら</p>
            </div>
          </BlackButton>
        </Link>
      </div>
    </>
  )
}

function ButtonComponent2Sp() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <Link
          to={containURL(
            "https://unfilter.co.jp/shop/cart/add?variant_id=1&quantity=1"
          )}
        >
          <BlackButton
            style={{ fontSize: "10px", width: "100px", height: "20px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p style={{ color: "#ffffff" }}>購入はこちら</p>
            </div>
          </BlackButton>
        </Link>
      </div>
    </>
  )
}

function ButtonComponent3() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <Link to={"/product"}>
          <WhiteButton>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p>詳しくみる</p>
            </div>
          </WhiteButton>
        </Link>
      </div>
    </>
  )
}

function ButtonComponent3Sp() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <Link to={"/product"}>
          <WhiteButton
            style={{ fontSize: "10px", width: "100px", height: "20px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p>詳しくみる</p>
            </div>
          </WhiteButton>
        </Link>
      </div>
    </>
  )
}
export default Top
